import * as React from 'react'
import Select, { components } from 'react-select'
import { ChevronDownIcon } from '@heroicons/react/20/solid'

const customStyles = {
  control: (base, state) => ({
    ...base,
    borderRadius: '0.5rem',
    borderColor: state.isFocused ? '#000000' : '#d1d5db',
    boxShadow: state.isFocused ? '0 0 0 1px #000000' : 'none',
    '&:hover': {
      borderColor: '#000000',
    },
    backgroundColor: '#fff',
    minHeight: '2.5rem',
  }),
  option: (base, state) => ({
    ...base,
    backgroundColor: state.isSelected
      ? '#f3f4f6'
      : state.isFocused
        ? '#f0f0f0ff'
        : 'white',
    color: 'black',
    padding: '0.5rem 1rem',
    cursor: 'pointer',
    fontSize: '0.875rem',
  }),
  multiValue: (base) => ({
    ...base,
    backgroundColor: '#e5e7eb',
  }),
  multiValueLabel: (base) => ({
    ...base,
    color: '#111827',
  }),
  multiValueRemove: (base) => ({
    ...base,
    color: '#000000',
    ':hover': {
      backgroundColor: '#f87171',
      color: 'white',
    },
  }),
  placeholder: (base) => ({
    ...base,
    color: '#000000',
    fontSize: '0.875rem',
  }),
  menu: (base) => ({
    ...base,
    borderRadius: '0.5rem',
    marginTop: '0.25rem',
    zIndex: 10,
  }),
}

const CustomDropdownIndicator = (props) => (
  <components.DropdownIndicator {...props}>
    <ChevronDownIcon className="h-5 w-5 text-gray-400" />
  </components.DropdownIndicator>
)

export const MultiSelect = React.forwardRef(
  (
    {
      options = [],
      value = [],
      onChange,
      placeholder = 'Select...',
      className = '',
      ...props
    },
    ref,
  ) => {
    const selected = React.useMemo(
      () => options.filter((opt) => value.includes(opt.value)),
      [options, value],
    )

    const handleChange = (selectedOptions) => {
      onChange(selectedOptions ? selectedOptions.map((opt) => opt.value) : [])
    }

    return (
      <Select
        ref={ref}
        isMulti
        options={options}
        value={selected}
        onChange={handleChange}
        placeholder={placeholder}
        className={className}
        classNamePrefix="react-select"
        styles={customStyles}
        components={{
          IndicatorSeparator: () => null,
          DropdownIndicator: CustomDropdownIndicator,
        }}
        {...props}
      />
    )
  },
)

MultiSelect.displayName = 'MultiSelect'
